module.exports = __webpack_public_path__ + "img/base_rear.f45f3d1c.jpeg";